
import React, { useState, useRef  } from 'react';
import '../../css_ai/AIMain.css';
import AIHeaderNavbar from "./AIHeaderNavbar";

function AIMain() {
  return (
    <div>

    </div>
  );
}

export default AIMain;
